export default ({ text, color }) => ({
    avatarRow: {
        marginTop: 10,
        marginRight: 10,
        float: 'left',
    },

    row: {
        padding: '12px 0px',
    },

    valueListTextMenu: {
        ...text.text_md,
    },

    info1: {
        ...text.text_md,
        color: '#000000',
        lineHeight: '13px',
        whiteSpace: 'normal',
    },

    info2: {
        ...text.text_md_hint,
        color: '#54585a',
        lineHeight: '15px',
        whiteSpace: 'normal',
    },

    info3: {
        ...text.text_xs_hint,
        lineHeight: '13px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
});
